/* Velqent Theme – kleines, abhängigkeitsfreies JS */
(function () {
  // Mengen-Buttons (+/-)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + (btn.dataset.qty === 'plus' ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Variantenwahl: Preis & Verfügbarkeit aktualisieren
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var root = select.closest('[data-product]');
    var dataEl = root && root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var priceEl = root.querySelector('[data-price]');
    var buyBtn = root.querySelector('[data-buy]');
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.textContent = v.available ? buyBtn.dataset.labelAdd : buyBtn.dataset.labelSoldout;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  // Mobiles Menü bei Klick auf Link schließen
  document.querySelectorAll('.menu-toggle a').forEach(function (a) {
    a.addEventListener('click', function () { a.closest('details').removeAttribute('open'); });
  });

  // Warenkorb: automatisch aktualisieren bei Mengenänderung
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var t;
    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(function () { cartForm.submit(); }, 500);
    });
  }

  // Mobile Kaufleiste erst zeigen, wenn der Haupt-Button aus dem Bild ist
  var bar = document.querySelector('[data-buy-bar]');
  var mainBtn = document.querySelector('[data-buy]');
  if (bar && mainBtn && 'IntersectionObserver' in window) {
    bar.classList.add('is-hidden');
    new IntersectionObserver(function (en) {
      bar.classList.toggle('is-hidden', en[0].isIntersecting || en[0].boundingClientRect.top > 0);
    }).observe(mainBtn);
  }
})();
